import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

export type BoxVariant = 'orange' | 'blue' | 'green' | 'red';

const bgByVariant = {
  orange: 'alert_orange_bg',
  blue: 'alert_blue_bg',
  green: 'alert_green_bg',
  red: 'alert_red_bg',
} as const;

const borderByVariant = {
  orange: 'alert_orange_border',
  blue: 'alert_blue_border',
  green: 'alert_green_border',
  red: 'alert_red_border',
} as const;

const iconByVariant = {
  orange: 'alert_orange_icon',
  blue: 'alert_blue_icon',
  green: 'alert_green_icon',
  red: 'alert_red_icon',
} as const;

const titleByVariant = {
  orange: 'alert_orange_title',
  blue: 'alert_blue_title',
  green: 'alert_green_title',
  red: 'alert_red_title',
} as const;

export const ContentContainer = styled.View`
  padding: ${RFValue(12)}px ${RFValue(24)}px;
  padding-bottom: 0px;
`;

export const IconCircle = styled.View<{variant?: BoxVariant}>`
  width: ${RFValue(52)}px;
  height: ${RFValue(52)}px;
  border-radius: ${RFValue(26)}px;
  background-color: ${({theme, variant = 'orange'}) =>
    theme.colors[bgByVariant[variant]]};
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-bottom: ${RFValue(14)}px;
`;

export const Icon = styled(FontAwesome5)<{variant?: BoxVariant}>`
  font-size: ${RFValue(24)}px;
  color: ${({theme, variant = 'orange'}) => theme.colors[iconByVariant[variant]]};
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(8)}px;
`;

export const Subtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  line-height: ${RFValue(19)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  margin-bottom: ${RFValue(16)}px;
`;

export const SubtitleBold = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
`;

export const WarningBox = styled.View<{variant?: BoxVariant}>`
  flex-direction: row;
  align-items: flex-start;
  gap: ${RFValue(10)}px;
  background-color: ${({theme, variant = 'orange'}) =>
    theme.colors[bgByVariant[variant]]};
  border-width: 1px;
  border-color: ${({theme, variant = 'orange'}) =>
    theme.colors[borderByVariant[variant]]};
  border-radius: ${RFValue(10)}px;
  padding: ${RFValue(12)}px;
  margin-bottom: ${RFValue(24)}px;
`;

export const WarningIcon = styled(FontAwesome5)<{variant?: BoxVariant}>`
  font-size: ${RFValue(14)}px;
  color: ${({theme, variant = 'orange'}) => theme.colors[iconByVariant[variant]]};
  margin-top: ${RFValue(2)}px;
`;

export const WarningText = styled.Text<{variant?: BoxVariant}>`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(12)}px;
  line-height: ${RFValue(17)}px;
  color: ${({theme, variant = 'orange'}) => theme.colors[titleByVariant[variant]]};
`;

export const ButtonsContainer = styled.View`
  gap:${RFValue(4)}px;
  padding-top: ${RFValue(4)}px;

`;
